import type { EnergyProfile } from "../domain/types.js";
import { DEFAULT_ENERGY_PROFILE, normalizeProfile } from "../domain/energy.js";

/**
 * 身體資料存在 localStorage，不進 D1——它只影響本機的估算顯示，
 * 不是需要跨裝置同步的健康紀錄。
 */
const ENERGY_PROFILE_KEY = "fight-health-energy-profile-v2";

export function loadEnergyProfile(): EnergyProfile {
  try {
    return normalizeProfile(JSON.parse(localStorage.getItem(ENERGY_PROFILE_KEY) || "null"));
  } catch {
    return { ...DEFAULT_ENERGY_PROFILE };
  }
}

export function saveEnergyProfile(profile: EnergyProfile): void {
  localStorage.setItem(ENERGY_PROFILE_KEY, JSON.stringify(profile));
}

/** NPC 台詞的輪替位置，只在當天有效。 */
const NPC_LINE_KEY = "fight-health-npc-line-v1";

export function npcLineOffset(date: string): number {
  try {
    const saved = JSON.parse(localStorage.getItem(NPC_LINE_KEY) || "{}");
    return saved.date === date ? Number(saved.offset) || 0 : 0;
  } catch {
    return 0;
  }
}

export function setNpcLineOffset(offset: number, date: string): void {
  localStorage.setItem(NPC_LINE_KEY, JSON.stringify({ date, offset }));
}
